<signature-pad [options]="{ 'minWidth': minWidth, 'canvasWidth': canvasWidth, 'canvasHeight': canvasHeight }"
  (drawStart)="drawStart()" (drawEnd)="drawComplete()"></signature-pad>